import React, { useEffect, useState } from "react";
import { BarChart3, Phone, Menu, X } from "lucide-react";
import { navLinks, PHONE, PHONE_TEL } from "../mock";

const Logo = () => (
  <a href="#top" className="flex items-center gap-2.5 select-none">
    <span className="grid place-items-center w-9 h-9 rounded-lg bg-[#7c3aed] text-white">
      <BarChart3 className="w-5 h-5" strokeWidth={2.5} />
    </span>
    <span className="font-display text-2xl font-semibold tracking-tight text-[#1e183a]">
      T4<span className="text-[#7c3aed]">TECH</span>
    </span>
  </a>
);

const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-[#f4f2fb]/90 backdrop-blur-md shadow-[0_4px_24px_-12px_rgba(19,26,51,0.25)]"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-5 lg:px-8 h-20 flex items-center justify-between">
        <Logo />

        <nav className="hidden lg:flex items-center gap-9">
          {navLinks.map((l) => (
            <a
              key={l.label}
              href={l.href}
              className="text-[15px] font-medium text-[#1e183a]/80 hover:text-[#7c3aed] transition-colors"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <a
          href={`tel:${PHONE_TEL}`}
          className="hidden lg:inline-flex items-center gap-2 rounded-full bg-[#7c3aed] hover:bg-[#6d28d9] text-white font-semibold text-sm px-5 py-3 transition-all hover:-translate-y-0.5 cta-glow"
        >
          <Phone className="w-4 h-4" strokeWidth={2.5} />
          Call Free {PHONE}
        </a>

        <button
          className="lg:hidden grid place-items-center w-10 h-10 rounded-lg text-[#1e183a]"
          onClick={() => setOpen((v) => !v)}
          aria-label="Menu"
        >
          {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden bg-[#f4f2fb] border-t border-[#1e183a]/10 px-5 py-4 space-y-1">
          {navLinks.map((l) => (
            <a
              key={l.label}
              href={l.href}
              onClick={() => setOpen(false)}
              className="block py-2.5 text-[#1e183a] font-medium"
            >
              {l.label}
            </a>
          ))}
          <a
            href={`tel:${PHONE_TEL}`}
            className="mt-2 inline-flex items-center gap-2 rounded-full bg-[#7c3aed] text-white font-semibold text-sm px-5 py-3"
          >
            <Phone className="w-4 h-4" /> Call Free {PHONE}
          </a>
        </div>
      )}
    </header>
  );
};

export default Header;
